import styled from "styled-components";
import { SCREENS } from "../../constants/screens";

export const Wrapper = styled.div.attrs({
  className: "flex overflow-y-auto flex-col",
})`
  width: 240px;
  height: 100vh;
  padding-top: 140px;
  position: fixed;
  z-index: 500;
  top: 0;
  right: 0;

  @media (max-width: ${SCREENS.desktop}) {
    top: 100px;
    padding-top: 100px;
  }
`;
